import { useEffect } from 'react'
import { reaction } from 'mobx'
import axios from 'axios'
import { upperCase } from 'lodash'

import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import mixpanelCookieService from 'Services/Cookie/MixpanelCookieService'

const buildAcceptLanguage = () => `${StoreTranslate.CurrentLanguage().toLowerCase()}-${StoreCountry.Country2().toUpperCase()}`

const useLanguageSync = () => {
    useEffect(() => {
        const qs = new URLSearchParams(window.location.search)
        const lang = qs.get('lang')

        if (lang) {
            const languageUpper = upperCase(lang)
            StoreTranslate.SetCurrentLanguage(languageUpper)
            mixpanelCookieService.setLanguage(languageUpper)
        }

        axios.defaults.headers.common['Accept-Language'] = buildAcceptLanguage()

        const disposerLanguageAxios = reaction(
            () => StoreTranslate.CurrentLanguage(),
            (next, prev) => {
                if (next !== prev) {
                    axios.defaults.headers.common['Accept-Language'] = `${next.toLowerCase()}-${StoreCountry.Country2().toUpperCase()}`
                }
            }
        )

        return () => {
            disposerLanguageAxios()
        }
    }, [])
}

export default useLanguageSync

